import { render, staticRenderFns } from "./teacherTextbook.vue?vue&type=template&id=9b4b6f5c&scoped=true"
import script from "./teacherTextbook.vue?vue&type=script&lang=js"
export * from "./teacherTextbook.vue?vue&type=script&lang=js"
import style0 from "./teacherTextbook.vue?vue&type=style&index=0&id=9b4b6f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4b6f5c",
  null
  
)

export default component.exports